module.exports = __webpack_public_path__ + "img/icon-time.355ccb2c.png";